<mat-card>
  <mat-card-content>
    <mat-card-title>Basic Chips</mat-card-title>
    <mat-card-subtitle><code>&lt;mat-chip&gt;</code>displays a list of values as individual, keyboard accessible, chips.
      <code
        class=""><a href="https://material.angular.io/pages/chips/overview">Official Component</a></code></mat-card-subtitle>
    <mat-chip-listbox aria-label="Fish selection">
      <mat-chip-option>One fish</mat-chip-option>
      <mat-chip-option>Two fish</mat-chip-option>
      <mat-chip-option color="accent" selected>Accent fish</mat-chip-option>
      <mat-chip-option color="warn">Warn fish</mat-chip-option>
    </mat-chip-listbox>

  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content>
    <mat-card-title>Chip input</mat-card-title>
    <mat-card-subtitle>The MatChipInput directive can be used together with a chip-list to streamline the interaction
      between the two components. This directive adds chip-specific behaviors to the input element within for adding and
      removing chips. </mat-card-subtitle>

    <mat-form-field class="demo-chip-list">
      <mat-label>Favorite Fruits</mat-label>
      <mat-chip-grid #chipGrid aria-label="Enter fruits">
        <mat-chip-row *ngFor="let fruit of fruits" (removed)="remove(fruit)" [editable]="true"
          (edited)="edit(fruit, $event)" [aria-description]="'press enter to edit ' + fruit.name">
          {{fruit.name}}
          <button matChipRemove [attr.aria-label]="'remove ' + fruit.name">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
        <input placeholder="New fruit..." [matChipInputFor]="chipGrid"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)" />
      </mat-chip-grid>
    </mat-form-field>
  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content>
    <mat-card-title>Stacked Chips</mat-card-title>
    <mat-card-subtitle>You can also stack the chips if you want them on top of each other and/or use the
      <code>(focus)</code> event to run custom code.</mat-card-subtitle>

    <mat-chip-listbox class="mat-mdc-chip-set-stacked" aria-label="Color selection">
      <mat-chip-option *ngFor="let chip of availableColors" selected [color]="chip.color">
        {{chip.name}}
      </mat-chip-option>
    </mat-chip-listbox>
  </mat-card-content>
</mat-card>
